import store from '../index.js'
import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        ruter: [],
        deltagere: [],
        ruteUpdates: {},
        deltagerRuteUpdates: {},
        teamId: null,
        isSubmitting: false
    },
    mutations: {
        set_team_id(state, id) {
            state.teamId = id
        },
        set_ruter(state, data) {
            state.ruter = data
        }, 
        set_deltagere(state, data) {
            state.deltagere = data
        },
        init_rute_counter(state, ruteId) {
            if (!state.ruteUpdates[ruteId]) {
                state.ruteUpdates[ruteId] = 0
            }
        },
        increment_rute_counter(state, ruteId) {
            state.ruteUpdates[ruteId]++
        },
        decrement_rute_counter(state, ruteId) {
            if (state.ruteUpdates[ruteId] == 0) return

            state.ruteUpdates[ruteId]--
        },
        set_rute_counter(state, { ruteId, count }) {    
            state.ruteUpdates[ruteId] = count
        },
        reset_rute_update(state, ruteId) {
            state.ruteUpdates[ruteId] = 0
        },
        init_deltager_counter(state, { deltagerId, ruteId }) {
            if (!state.deltagerRuteUpdates[deltagerId]) {
                state.deltagerRuteUpdates[deltagerId] = {}
            }

            if (!state.deltagerRuteUpdates[deltagerId][ruteId]) {
                state.deltagerRuteUpdates[deltagerId][ruteId] = 0
            }
        },
        increment_deltager_counter(state, { deltagerId, ruteId }) {
            state.deltagerRuteUpdates[deltagerId][ruteId]++
        },
        decrement_deltager_counter(state, { deltagerId, ruteId }) {
            if (state.deltagerRuteUpdates[deltagerId][ruteId] == 0) return

            state.deltagerRuteUpdates[deltagerId][ruteId]--
        },
        set_deltager_counter(state, { deltagerId, ruteId, count }) {
            state.deltagerRuteUpdates[deltagerId][ruteId] = count
        },
        reset_deltager_update(state, { deltagerId, ruteId }) {
            state.deltagerRuteUpdates[deltagerId][ruteId] = 0
        },
        set_is_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        }
    },
    getters: {
        getDeltagerRuteAmount: (state) => ({ deltagerId, ruteId }) => {
            if (!state.deltagerRuteUpdates[deltagerId]) {
                return 0
            }

            return state.deltagerRuteUpdates[deltagerId][ruteId]
        },
        shouldDisableApplyButton: (state) => ({ deltagerId, ruteId }) => {
            if (deltagerId) {
                const ruteUpdates = state.deltagerRuteUpdates[deltagerId]
                if (ruteUpdates && ruteUpdates[ruteId] > 0) {
                    return false
                }

                return true
            }

            if (state.ruteUpdates[ruteId] > 0) {
                return false
            }

            return true            
        }
    },
    actions: {   
        getStafetRoundCounter(context) {
            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_ROUND_COUNTER
                .replace('[pageId]', store.state.main.page_id)
                .replace('[holdKode]', context.state.teamId)}`

            context.commit('set_is_submitting', true)

            globalFetch(url)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((data) => {
                    const ruterArray = []
                    if (data.ruter) {
                        data.ruter.forEach((rute) => {
                            context.commit('init_rute_counter', rute.id)

                            ruterArray.push({
                                ruteName: rute.name,
                                id: rute.id,
                                meters: rute.meters,
                                detailsKm: rute.detailsKm,
                                detailsRounds: rute.detailsRounds,
                                dynamicUpdate: true
                            })
                        })
                    }

                    const deltagereResult = []
                    if (data.deltagere) {
                        data.deltagere.forEach((deltager) => {
                            const ruterForDeltager = {}
                            deltager.ruter.forEach(r => {
                                const rute = ruterArray.find(
                                    (rute) => rute.id === r.id
                                )

                                context.commit('init_deltager_counter', { 
                                    deltagerId: deltager.deltagerId, 
                                    ruteId: rute.id
                                })

                                ruterForDeltager[rute.id] = {
                                    id: rute.id,
                                    ruteName: rute.ruteName,
                                    meters: rute.meters,
                                    detailsKm: r.detailsKm,
                                    detailsRounds: r.detailsRounds
                                }
                            })
                            
                            deltagereResult.push({
                                id: deltager.deltagerId,
                                ruter: ruterForDeltager,
                                participantName: deltager.name,
                                participantRole: deltager.role,
                                dynamicUpdate: false
                            })
                        })
                    }
                    context.commit('set_ruter', ruterArray)
                    context.commit('set_deltagere', deltagereResult)
                    context.commit('set_is_submitting', false)
                })
                .catch((err) => {
                    console.error('Der skete en fejl med opdatering af stafetten', err)
                    context.commit('set_is_submitting', false)
                })
        },
        stafetRoundCounterSubmit(context, { deltagerId, ruteId }) {
            const ruterArray = []
            const deltagerArray = []
            
            if (deltagerId) {
                deltagerArray.push({
                    id: deltagerId,
                    ruter: [{
                        id: ruteId,
                        amount: context.state.deltagerRuteUpdates[deltagerId][ruteId]
                    }]
                })
            } else {
                ruterArray.push({
                    id: ruteId,
                    amount: context.state.ruteUpdates[ruteId]
                })
            }

            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_ROUND_COUNTER
                .replace('[pageId]', store.state.main.page_id)
                .replace('[holdKode]', context.state.teamId)}`
            const method = process.env.POSTMETHOD

            const body = {
                ruter: ruterArray,
                deltagere: deltagerArray
            }

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response
                    throw new Error(response.error)
                })
                .then(() => {
                    if (deltagerId) {
                        context.commit('reset_deltager_update', { deltagerId, ruteId })                    
                    } else {
                        context.commit('reset_rute_update', ruteId)
                    }

                    context.dispatch('getStafetRoundCounter')
                    context.commit('set_is_submitting', false)
                })
                .catch((err) => {
                    console.error('Der skete en fejl med opdatering af stafetten', err)
                    context.commit('set_is_submitting', false)
                })
        }
    }
}

